import { render, staticRenderFns } from "./manage-advertisements.vue?vue&type=template&id=d642d5f6&"
import script from "./manage-advertisements.vue?vue&type=script&lang=js&"
export * from "./manage-advertisements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports